import { h, Component } from 'preact';
import styles from './border.css';

export default class Content extends Component {
	render({ color }) {
		return <span className={`${styles.border} ${styles[color]}`} />;
	}
}



// WEBPACK FOOTER //
// ./components/border/border.jsx